import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { compose } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../../../reducers/Service/actions';

import { EditInput } from '../PickupDelivery/components';

import {
  Error,
  FlightContainer,
  PnrContainer,
  Row,
  Span,
  Text,
  Title,
  Warning,
  withFlightPnrStyles,
} from './style';

const showTimeNoOffset = item => (item ? `${moment.parseZone(item).utcOffset(0, true).format('kk:mm')} - ` : '');

export class FlightPnr extends Component {
  onCabinClassChange = (cabinClass) => {
    const { id, updateService } = this.props;

    updateService({
      flightInfo: {
        cabinClass,
      },
      serviceId: id,
    });
  };

  onPnrChange = (pnr) => {
    const { id, updateService } = this.props;

    updateService({
      flightInfo: {
        pnr,
      },
      serviceId: id,
    });
  };

  render() {
    const {
      flightInfo = {}, paxs, isCheckin, classes,
    } = this.props;

    const {
      cabinClass, destination = {}, flight, origin, pnr,
    } = flightInfo;
    const surname = (paxs[0] && paxs[0].surname) || '';
    if (!origin && !isCheckin) return undefined;
    const departureDate = origin.date;
    const arrivalDate = destination.date;

    return (
      <div className={classes.root}>
        <span>
          <Title>Flight Data</Title>
          <FlightContainer>
            <Text>
              <Span>Flight number</Span>
              {flight || <Error>Not found</Error>}
            </Text>
            {origin && (
            <Fragment>
              <Text>
                <Span>Departure</Span>
                {`${showTimeNoOffset(departureDate)}${origin.airportCode || ''} ${(origin.terminal
                  && (origin.terminal.name || `T${origin.terminal.number}`))
                  || ''}`}
              </Text>
              <Text>
                <Span>Arrival</Span>
                {`${showTimeNoOffset(arrivalDate)}${destination.airportCode || ''} ${(destination.terminal
                  && (destination.terminal.name || `T${destination.terminal.number}`))
                  || ''}`}
              </Text>
            </Fragment>
            )}
            {isCheckin && (
            <Text>
              <Row>
                <Span>Cabin Class</Span>
                <EditInput onChange={this.onCabinClassChange} value={cabinClass}>
                  {cabinClass || <Warning>Not found</Warning>}
                </EditInput>
              </Row>
            </Text>
            )}
          </FlightContainer>
        </span>
        <span>
          {isCheckin && (
          <Fragment>
            <Title>PNR</Title>
            <PnrContainer>
              <Text>
                <Span>Surname</Span>
                {surname || <Warning>Not found</Warning>}
              </Text>
              <Row>
                <Text>
                  <Span>Code</Span>
                </Text>
                <Text>
                  <EditInput value={pnr} onChange={this.onPnrChange}>
                    {pnr || <Warning>Not found</Warning>}
                  </EditInput>
                </Text>
              </Row>
            </PnrContainer>
          </Fragment>
          )}
        </span>
      </div>
    );
  }
}

FlightPnr.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
  flightInfo   : PropTypes.shape({}),
  id           : PropTypes.string,
  isCheckin    : PropTypes.bool,
  paxs         : PropTypes.arrayOf(PropTypes.shape({})),
  updateService: PropTypes.func,
};
FlightPnr.defaultProps = {
  flightInfo: {
    destination: {
      cityCode: '',
      date    : undefined,
      terminal: {
        name: '',
      },
    },
    flight: '',
    origin: {
      cityCode: '',
      date    : undefined,
      terminal: {
        name: '',
      },
    },
    pnr    : '',
    surname: '',
  },
  id           : '',
  isCheckin    : false,
  paxs         : [],
  updateService: () => {},
};

const mapDispatchToProps = dispatch => ({
  updateService: data => dispatch(actions.updateService(data)),
});

export default compose(
  withFlightPnrStyles,
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(FlightPnr);
